// ─── Fund Hierarchy ───────────────────────────────────────────────────────────

export const DR_FUNDS = [
  {
    id: 'fund-1',
    label: 'Greenfield Renewables Fund I',
    shortLabel: 'Fund I',
    vintage: 2024,
    status: 'Closed',
    icon: 'Zap',
    description: 'Renewable energy infrastructure across Southern Europe',
  },
  {
    id: 'fund-2',
    label: 'Greenfield Infrastructure Fund II',
    shortLabel: 'Fund II',
    vintage: 2025,
    status: 'Raising',
    icon: 'Building2',
    description: 'Digital infrastructure and connectivity assets in Northern Europe',
  },
];

export const DR_SECTORS = [
  { id: 'sec-renewable', fundId: 'fund-1', label: 'Renewable Energy', icon: 'Leaf' },
  { id: 'sec-transport', fundId: 'fund-1', label: 'Transport & Utilities', icon: 'Truck' },
  { id: 'sec-digital',   fundId: 'fund-2', label: 'Digital Infrastructure', icon: 'Wifi' },
];

export const DR_PROJECTS = [
  { id: 'proj-solano',  sectorId: 'sec-renewable', fundId: 'fund-1', label: 'Solano Wind Farm',      country: 'Spain',    icon: 'Wind' },
  { id: 'proj-meridian',sectorId: 'sec-renewable', fundId: 'fund-1', label: 'Meridian Solar Park',   country: 'Portugal', icon: 'Sun' },
  { id: 'proj-avon',    sectorId: 'sec-transport',  fundId: 'fund-1', label: 'Avon Water Treatment', country: 'UK',       icon: 'Droplets' },
  { id: 'proj-tyne',    sectorId: 'sec-transport',  fundId: 'fund-1', label: 'Tyne Bridge Toll Road', country: 'UK',      icon: 'Route' },
  { id: 'proj-nordic',  sectorId: 'sec-digital',   fundId: 'fund-2', label: 'Nordic Fibre Network',  country: 'Sweden',   icon: 'Network' },
  { id: 'proj-porto',   sectorId: 'sec-digital',   fundId: 'fund-2', label: 'Porto Digital Hub',     country: 'Portugal', icon: 'Server' },
];

// ─── Document Categories (leaf-level filter) ──────────────────────────────────

export const DOCUMENT_CATEGORIES = [
  { id: 'all',           label: 'All Documents',          icon: 'FolderOpen' },
  { id: 'legal',         label: 'Legal & Constitutional', icon: 'Scale' },
  { id: 'financial',     label: 'Financial Models',       icon: 'BarChart2' },
  { id: 'due-diligence', label: 'Due Diligence',          icon: 'Search' },
  { id: 'regulatory',    label: 'Regulatory & Compliance',icon: 'ShieldCheck' },
  { id: 'esg',           label: 'ESG & Reporting',        icon: 'Leaf' },
  { id: 'correspondence',label: 'Correspondence',         icon: 'Mail' },
];

// Keep CATEGORIES as alias for any component that still references the old name
export const CATEGORIES = DOCUMENT_CATEGORIES;

// ─── Access & File Type Config ────────────────────────────────────────────────

export const ACCESS_LEVELS = {
  restricted:   { label: 'Restricted',   color: '#dc2626', bg: 'rgba(220,38,38,0.1)',   border: 'rgba(220,38,38,0.3)' },
  confidential: { label: 'Confidential', color: '#d97706', bg: 'rgba(217,119,6,0.1)',   border: 'rgba(217,119,6,0.3)' },
  internal:     { label: 'Internal',     color: '#2563eb', bg: 'rgba(37,99,235,0.1)',    border: 'rgba(37,99,235,0.3)' },
  public:       { label: 'Public',       color: '#16a34a', bg: 'rgba(22,163,74,0.1)',    border: 'rgba(22,163,74,0.3)' },
};

export const FILE_TYPE_CONFIG = {
  pdf:  { color: '#dc2626', bg: 'rgba(220,38,38,0.1)',  icon: 'FileText' },
  xlsx: { color: '#16a34a', bg: 'rgba(22,163,74,0.1)',  icon: 'FileSpreadsheet' },
  docx: { color: '#2563eb', bg: 'rgba(37,99,235,0.1)',  icon: 'FileType' },
};

// ─── Documents ────────────────────────────────────────────────────────────────

export const DOCUMENTS = [
  {
    id: 'doc-1',
    name: 'Solano Wind Farm SPV — Shareholders Agreement v2.1',
    category: 'legal',
    fundId: 'fund-1', sectorId: 'sec-renewable', projectId: 'proj-solano',
    fileType: 'pdf', version: 'v2.1', modifiedDate: '14 Feb 2026', modifiedBy: 'Sarah Mitchell',
    fileSize: '4.2 MB', accessLevel: 'restricted', pages: 48,
    versions: [
      { version: 'v2.1', date: '14 Feb 2026', uploadedBy: 'Sarah Mitchell', changeNote: 'Updated indemnity clauses per legal review', size: '4.2 MB' },
      { version: 'v2.0', date: '02 Jan 2026', uploadedBy: 'James Thornton', changeNote: 'Revised shareholder rights section', size: '4.0 MB' },
      { version: 'v1.1', date: '15 Nov 2025', uploadedBy: 'Sarah Mitchell', changeNote: 'Minor formatting corrections', size: '3.9 MB' },
      { version: 'v1.0', date: '01 Oct 2025', uploadedBy: 'James Thornton', changeNote: 'Initial draft', size: '3.8 MB' },
    ],
    accessList: [
      { name: 'Sarah Mitchell', role: 'Admin', access: 'Full access', granted: '01 Oct 2025' },
      { name: 'James Thornton', role: 'Sponsor', access: 'Download', granted: '01 Oct 2025' },
      { name: 'Priya Sharma',   role: 'Investor', access: 'View only', granted: '15 Nov 2025' },
    ],
  },
  {
    id: 'doc-2',
    name: 'Constitutional Documents — Avon Water Treatment SPV',
    category: 'legal',
    fundId: 'fund-1', sectorId: 'sec-transport', projectId: 'proj-avon',
    fileType: 'pdf', version: 'v1.3', modifiedDate: '20 Jan 2026', modifiedBy: 'James Thornton',
    fileSize: '2.8 MB', accessLevel: 'confidential', pages: 32,
    versions: [
      { version: 'v1.3', date: '20 Jan 2026', uploadedBy: 'James Thornton', changeNote: 'Board approval incorporated', size: '2.8 MB' },
      { version: 'v1.2', date: '05 Dec 2025', uploadedBy: 'Sarah Mitchell', changeNote: 'Regulatory amendments', size: '2.7 MB' },
      { version: 'v1.0', date: '10 Sep 2025', uploadedBy: 'James Thornton', changeNote: 'Initial filing', size: '2.5 MB' },
    ],
    accessList: [
      { name: 'Sarah Mitchell', role: 'Admin', access: 'Full access', granted: '10 Sep 2025' },
      { name: 'James Thornton', role: 'Sponsor', access: 'Full access', granted: '10 Sep 2025' },
    ],
  },
  {
    id: 'doc-3',
    name: 'Shareholder Agreement — Nordic Fibre Network SPV',
    category: 'legal',
    fundId: 'fund-2', sectorId: 'sec-digital', projectId: 'proj-nordic',
    fileType: 'docx', version: 'v3.0', modifiedDate: '28 Feb 2026', modifiedBy: 'Priya Sharma',
    fileSize: '1.6 MB', accessLevel: 'confidential', pages: 24,
    versions: [
      { version: 'v3.0', date: '28 Feb 2026', uploadedBy: 'Priya Sharma', changeNote: 'Final execution version', size: '1.6 MB' },
      { version: 'v2.0', date: '10 Feb 2026', uploadedBy: 'James Thornton', changeNote: 'Negotiated amendments', size: '1.5 MB' },
      { version: 'v1.0', date: '15 Jan 2026', uploadedBy: 'Priya Sharma', changeNote: 'First draft', size: '1.4 MB' },
    ],
    accessList: [
      { name: 'Sarah Mitchell', role: 'Admin', access: 'Full access', granted: '15 Jan 2026' },
      { name: 'Priya Sharma',   role: 'Investor', access: 'View only', granted: '15 Jan 2026' },
    ],
  },
  {
    id: 'doc-4',
    name: 'Solano Wind Farm — Financial Model v4.2',
    category: 'financial',
    fundId: 'fund-1', sectorId: 'sec-renewable', projectId: 'proj-solano',
    fileType: 'xlsx', version: 'v4.2', modifiedDate: '01 Mar 2026', modifiedBy: 'Sarah Mitchell',
    fileSize: '8.7 MB', accessLevel: 'restricted', pages: 1,
    versions: [
      { version: 'v4.2', date: '01 Mar 2026', uploadedBy: 'Sarah Mitchell', changeNote: 'Updated capex assumptions', size: '8.7 MB' },
      { version: 'v4.1', date: '15 Feb 2026', uploadedBy: 'Sarah Mitchell', changeNote: 'Revised IRR sensitivity tables', size: '8.5 MB' },
      { version: 'v4.0', date: '01 Jan 2026', uploadedBy: 'James Thornton', changeNote: 'Q4 2025 actuals incorporated', size: '8.2 MB' },
      { version: 'v3.0', date: '01 Oct 2025', uploadedBy: 'Sarah Mitchell', changeNote: 'Base case refresh', size: '7.9 MB' },
    ],
    accessList: [
      { name: 'Sarah Mitchell', role: 'Admin', access: 'Full access', granted: '01 Oct 2025' },
      { name: 'James Thornton', role: 'Sponsor', access: 'Download', granted: '01 Oct 2025' },
    ],
  },
  {
    id: 'doc-5',
    name: 'Meridian Solar Park — Cap Table v1.3',
    category: 'financial',
    fundId: 'fund-1', sectorId: 'sec-renewable', projectId: 'proj-meridian',
    fileType: 'xlsx', version: 'v1.3', modifiedDate: '18 Feb 2026', modifiedBy: 'James Thornton',
    fileSize: '5.3 MB', accessLevel: 'restricted', pages: 1,
    versions: [
      { version: 'v1.3', date: '18 Feb 2026', uploadedBy: 'James Thornton', changeNote: 'Post-close actuals', size: '5.3 MB' },
      { version: 'v1.0', date: '20 Nov 2025', uploadedBy: 'Sarah Mitchell', changeNote: 'Initial projections', size: '4.8 MB' },
    ],
    accessList: [
      { name: 'Sarah Mitchell', role: 'Admin', access: 'Full access', granted: '20 Nov 2025' },
      { name: 'James Thornton', role: 'Sponsor', access: 'Download', granted: '20 Nov 2025' },
      { name: 'Priya Sharma',   role: 'Investor', access: 'View only', granted: '05 Dec 2025' },
    ],
  },
  {
    id: 'doc-6',
    name: 'Avon Water Treatment Works — Technical Due Diligence Report',
    category: 'due-diligence',
    fundId: 'fund-1', sectorId: 'sec-transport', projectId: 'proj-avon',
    fileType: 'pdf', version: 'v1.2', modifiedDate: '10 Feb 2026', modifiedBy: 'Priya Sharma',
    fileSize: '12.4 MB', accessLevel: 'confidential', pages: 86,
    versions: [
      { version: 'v1.2', date: '10 Feb 2026', uploadedBy: 'Priya Sharma', changeNote: 'Addendum: flood risk assessment', size: '12.4 MB' },
      { version: 'v1.1', date: '20 Jan 2026', uploadedBy: 'James Thornton', changeNote: 'Peer review comments addressed', size: '11.8 MB' },
      { version: 'v1.0', date: '05 Jan 2026', uploadedBy: 'Priya Sharma', changeNote: 'Initial report', size: '11.2 MB' },
    ],
    accessList: [
      { name: 'Sarah Mitchell', role: 'Admin', access: 'Full access', granted: '05 Jan 2026' },
      { name: 'Priya Sharma',   role: 'Investor', access: 'View only', granted: '05 Jan 2026' },
    ],
  },
  {
    id: 'doc-7',
    name: 'Tyne Bridge Toll Road — Environmental Impact Assessment',
    category: 'due-diligence',
    fundId: 'fund-1', sectorId: 'sec-transport', projectId: 'proj-tyne',
    fileType: 'pdf', version: 'v2.0', modifiedDate: '25 Jan 2026', modifiedBy: 'Sarah Mitchell',
    fileSize: '9.1 MB', accessLevel: 'internal', pages: 64,
    versions: [
      { version: 'v2.0', date: '25 Jan 2026', uploadedBy: 'Sarah Mitchell', changeNote: 'Regulator-approved final version', size: '9.1 MB' },
      { version: 'v1.0', date: '10 Dec 2025', uploadedBy: 'James Thornton', changeNote: 'Draft for consultation', size: '8.6 MB' },
    ],
    accessList: [
      { name: 'Sarah Mitchell', role: 'Admin', access: 'Full access', granted: '10 Dec 2025' },
      { name: 'James Thornton', role: 'Sponsor', access: 'Download', granted: '10 Dec 2025' },
      { name: 'Priya Sharma',   role: 'Investor', access: 'View only', granted: '20 Dec 2025' },
    ],
  },
  {
    id: 'doc-8',
    name: 'Solano Wind Farm SPV — KYC Pack',
    category: 'regulatory',
    fundId: 'fund-1', sectorId: 'sec-renewable', projectId: 'proj-solano',
    fileType: 'pdf', version: 'v1.1', modifiedDate: '05 Mar 2026', modifiedBy: 'James Thornton',
    fileSize: '3.5 MB', accessLevel: 'restricted', pages: 28,
    versions: [
      { version: 'v1.1', date: '05 Mar 2026', uploadedBy: 'James Thornton', changeNote: 'Annual refresh', size: '3.5 MB' },
      { version: 'v1.0', date: '01 Oct 2025', uploadedBy: 'Sarah Mitchell', changeNote: 'Initial submission', size: '3.2 MB' },
    ],
    accessList: [
      { name: 'Sarah Mitchell', role: 'Admin', access: 'Full access', granted: '01 Oct 2025' },
    ],
  },
  {
    id: 'doc-9',
    name: 'FCA Regulatory Filing — Q4 2025',
    category: 'regulatory',
    fundId: 'fund-1', sectorId: 'sec-transport', projectId: 'proj-tyne',
    fileType: 'pdf', version: 'v1.0', modifiedDate: '31 Jan 2026', modifiedBy: 'Sarah Mitchell',
    fileSize: '1.9 MB', accessLevel: 'internal', pages: 18,
    versions: [
      { version: 'v1.0', date: '31 Jan 2026', uploadedBy: 'Sarah Mitchell', changeNote: 'Submitted to FCA', size: '1.9 MB' },
    ],
    accessList: [
      { name: 'Sarah Mitchell', role: 'Admin', access: 'Full access', granted: '31 Jan 2026' },
      { name: 'James Thornton', role: 'Sponsor', access: 'View only', granted: '31 Jan 2026' },
    ],
  },
  {
    id: 'doc-10',
    name: 'ESG Impact Report — Annual 2025',
    category: 'esg',
    fundId: 'fund-1', sectorId: 'sec-renewable', projectId: 'proj-solano',
    fileType: 'pdf', version: 'v1.0', modifiedDate: '28 Feb 2026', modifiedBy: 'Priya Sharma',
    fileSize: '6.8 MB', accessLevel: 'public', pages: 52,
    versions: [
      { version: 'v1.0', date: '28 Feb 2026', uploadedBy: 'Priya Sharma', changeNote: 'Published annual report', size: '6.8 MB' },
    ],
    accessList: [
      { name: 'Sarah Mitchell', role: 'Admin', access: 'Full access', granted: '28 Feb 2026' },
      { name: 'Priya Sharma',   role: 'Investor', access: 'Download', granted: '28 Feb 2026' },
      { name: 'James Thornton', role: 'Sponsor', access: 'Download', granted: '28 Feb 2026' },
    ],
  },
  {
    id: 'doc-11',
    name: 'Quarterly Portfolio Report — Q4 2025',
    category: 'esg',
    fundId: 'fund-1', sectorId: 'sec-renewable', projectId: 'proj-meridian',
    fileType: 'pdf', version: 'v1.0', modifiedDate: '15 Jan 2026', modifiedBy: 'Sarah Mitchell',
    fileSize: '4.1 MB', accessLevel: 'internal', pages: 36,
    versions: [
      { version: 'v1.0', date: '15 Jan 2026', uploadedBy: 'Sarah Mitchell', changeNote: 'Q4 2025 quarterly report', size: '4.1 MB' },
    ],
    accessList: [
      { name: 'Sarah Mitchell', role: 'Admin', access: 'Full access', granted: '15 Jan 2026' },
      { name: 'Priya Sharma',   role: 'Investor', access: 'View only', granted: '15 Jan 2026' },
      { name: 'James Thornton', role: 'Sponsor', access: 'Download', granted: '15 Jan 2026' },
    ],
  },
  {
    id: 'doc-12',
    name: 'Porto Digital Hub SPV — Term Sheet v1.0',
    category: 'correspondence',
    fundId: 'fund-2', sectorId: 'sec-digital', projectId: 'proj-porto',
    fileType: 'pdf', version: 'v1.0', modifiedDate: '10 Mar 2026', modifiedBy: 'Ana Ferreira',
    fileSize: '1.2 MB', accessLevel: 'confidential', pages: 12,
    versions: [
      { version: 'v1.0', date: '10 Mar 2026', uploadedBy: 'Ana Ferreira', changeNote: 'Initial term sheet', size: '1.2 MB' },
    ],
    accessList: [
      { name: 'Sarah Mitchell', role: 'Admin', access: 'Full access', granted: '10 Mar 2026' },
      { name: 'Ana Ferreira',   role: 'Analyst', access: 'Download', granted: '10 Mar 2026' },
    ],
  },
];
